import React, { Component } from 'react';
import { Button, Divider, Form, Grid, Header, Input, Segment } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchDisabledAccesses, fetchFuelType, fetchManufacturers,
    fetchOrgUnitPropertiesByOrganizationalUnitId,
    fetchPropertiesByOrganizationalUnitId,
    fetchRoomTypes, fetchStatuses, fetchTypes
} from '../Lookups/util';
import { checkFaculty, formatListForDropdownOptions } from '../util/util';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

class NewVehicle extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            // Form data
            manufacturer: null,
            type: null,
            status: null,
            model: '',
            licencePlate: '',
            chassisNumber: '',
            numberOfSeats: '',
            purchaseYear: '',
            productionYear: '',
            fuelType: null,
            vehicleId: null,
            optLock: null,

        };
        this.fetchLookups = this.fetchLookups.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLicencePlateChange = this.handleLicencePlateChange.bind(this);
    }

    componentDidMount() {
        this.fetchLookups(this.props.activeRole, this.props.organizationalUnitId);
    }

    fetchLookups(activeRole, organizationalUnitId) {
        this.setState({ organizationalUnitId });
        axios.all([fetchManufacturers(), fetchTypes(), fetchStatuses(), fetchFuelType()])
            .then(axios.spread((manufacturersRes, typesRes, statusesRes, fuelTypesRes, vehiclesRes) => {
                const manufacturers = formatListForDropdownOptions(manufacturersRes.data);
                const types = formatListForDropdownOptions(typesRes.data);
                const statuses = formatListForDropdownOptions(statusesRes.data);
                const fuelTypes = formatListForDropdownOptions(fuelTypesRes.data);

                const lookups = {
                    manufacturers,
                    types,
                    statuses,
                    fuelTypes,
                };
                this.setState({
                    manufacturersOptions: manufacturers,
                    typesOptions: types,
                    statusesOptions: statuses,
                    fuelTypeOptions: fuelTypes
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    handleLicencePlateChange(event, { value }) {
        this.setState({
            licencePlate: value.toUpperCase()
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value !== '' ? value : null,
        });
    }

    sendVehicleRequest() {
        const {
            manufacturer,
            model,
            type,
            licencePlate,
            chassisNumber,
            numberOfSeats,
            purchaseYear,
            productionYear,
            fuelType,
            status,
            organizationalUnitId,
        } = this.state;

        if (type === null || chassisNumber === '' || licencePlate === '' || chassisNumber === null || licencePlate === null) {
            this.setState({
                typeError: type === null,
                chassisNumberError: chassisNumber === '' || chassisNumber === null,
                licencePlateError: licencePlate === '' || licencePlate === null,
            });

            toast('Nisu sva potrebna polja unešena!');
            return;
        }

        const vehicleRequest = {
            organizationalUnit: organizationalUnitId ? { id: organizationalUnitId } : null,
            manufacturer: manufacturer ? { id: manufacturer } : null,
            model: model === '' ? null : model,
            type: type ? { id: type } : null,
            licencePlate: licencePlate === '' ? null : licencePlate,
            chassisNumber: chassisNumber === '' ? null : chassisNumber,
            numberOfSeats: numberOfSeats === '' ? null : numberOfSeats,
            productionYear: productionYear === '' ? null : productionYear,
            purchaseYear: purchaseYear === '' ? null : purchaseYear,
            status: status ? { id: status } : null,
            fuelType: fuelType ? { id: fuelType } : null,
        };


        axios.post('/assets/vehicle/', { ...vehicleRequest })
            .then(res => {
                this.props.fetchAllVehicles();
                this.props.closeForm();
            })
            .catch(err => {
                console.log(err);
                toast('Došlo je do greške prilikom dodavanja vozila!');
            });
    }


    render() {
        return (
            <div>
                <Segment secondary clearing>
                    <Form noValidate>




                        <Form.Group widths="equal" >
                            <Form.Field
                                label="Model"
                                control={Input}
                                name="model"
                                value={this.state.model}
                                onChange={this.handleInputChange}
                                placeholder="Model"
                            />
                            <Form.Dropdown
                                clearable
                                label="Proizvođač"
                                placeholder="Proizvođač"
                                value={this.state.manufacturer}
                                onChange={this.handleInputChange}
                                name="manufacturer"
                                options={this.state.manufacturersOptions}
                                search
                                selection
                                fluid
                            />
                            <Form.Dropdown
                                clearable
                                label="Tip"
                                placeholder="Tip"
                                value={this.state.type}
                                onChange={this.handleInputChange}
                                name="type"
                                options={this.state.typesOptions}
                                search
                                fluid
                                selection
                                required
                                error={this.state.typeError}
                            />
                            <Form.Field
                                type="text"
                                label="Tablice"
                                control={Input}
                                name="licencePlate"
                                value={this.state.licencePlate}
                                onChange={this.handleLicencePlateChange}
                                placeholder="Tablice"
                                required
                                error={this.state.licencePlateError}
                            />
                            <Form.Dropdown
                                clearable
                                label="Tip goriva"
                                placeholder="Tip goriva"
                                value={this.state.fuelType}
                                onChange={this.handleInputChange}
                                name="fuelType"
                                options={this.state.fuelTypeOptions}
                                selection
                                search
                                fluid
                            />
                        </Form.Group>


                        <Form.Group widths="equal" >

                            <Form.Field
                                type="text"
                                label="Šasija"
                                control={Input}
                                name="chassisNumber"
                                value={this.state.chassisNumber}
                                onChange={this.handleInputChange}
                                placeholder="Broj šasije"
                                required
                                error={this.state.chassisNumberError}
                            />
                            <Form.Field
                                type="number"
                                label="Broj sjedišta"
                                control={Input}
                                name="numberOfSeats"
                                value={this.state.numberOfSeats}
                                onChange={this.handleInputChange}
                                placeholder="Broj sjedišta"
                            />

                            <Form.Field
                                type="number"
                                label="Godina proizvodnje"
                                control={Input}
                                name="productionYear"
                                value={this.state.productionYear}
                                onChange={this.handleInputChange}
                                placeholder="Godina proizvodnje"
                            />
                            <Form.Field
                                type="number"
                                label="Godina nabavke"
                                control={Input}
                                name="purchaseYear"
                                value={this.state.purchaseYear}
                                onChange={this.handleInputChange}
                                placeholder="Godina nabavke"
                            />
                            <Form.Dropdown
                                clearable
                                label="Status"
                                placeholder="Status"
                                value={this.state.status}
                                onChange={this.handleInputChange}
                                name="status"
                                options={this.state.statusesOptions}
                                selection
                                search
                                fluid
                            />

                        </Form.Group>


                        <Button
                            floated="right"
                            onClick={this.props.closeForm}
                            basic
                            color="blue"
                        >Odustani
                        </Button>

                        <Button
                            floated="right"
                            color="blue"
                            onClick={
                                () => {
                                    this.sendVehicleRequest();
                                }
                            }
                        >
                            Dodaj
                        </Button>
                    </Form>
                </Segment>
            </div>
        );
    }
}

export default NewVehicle;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/NewVehicle.js